'use client';

import { Checkbox } from '@apex-titan/ui';
import { type ComponentProps } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormCheckboxProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<
    ComponentProps<typeof Checkbox>,
    'checked' | 'onCheckedChange' | 'name' | 'defaultValue'
  >;

export function FormCheckbox<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...checkboxProps
}: FormCheckboxProps<T>) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <Checkbox
      {...checkboxProps}
      ref={field.ref}
      checked={!!field.value}
      onCheckedChange={field.onChange}
      onBlur={field.onBlur}
      errorMessage={fieldState.error?.message}
    />
  );
}
